module.exports = __webpack_public_path__ + "static/media/SLP-GuidanceCardsLogo.47f2ee80.png";